import React from 'react';
import { makeStyles } from '@mui/styles';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from './Button';
import { Email, GetApp } from '@mui/icons-material';
import { ReactComponent as TickIcon } from "../../images/tick.svg"
import { ReactComponent as RightArrowIcon } from "../../images/right-arrow.svg"
import { ReactComponent as CrossIcon } from '../../images/cross.svg';
import { ReactComponent as DownArrowIcon } from '../../images/arrow-down.svg';
import { StepConnector } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

const useStyles = makeStyles((theme) => ({
  stepLabel: {
  '& .MuiStepLabel-label': {
    fontSize: '14px',
    fontWeight: 600,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  '& .MuiStepLabel-iconContainer': {
    paddingRight: '12px',
  }
},
rightArrow: {
  display: 'flex',
  alignItems: 'center',
  marginLeft: '12px',
},

  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
    textAlign: 'right'
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
    textAlign: 'right'
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
  stepRoot: {
    '& .MuiStepLabel-root': {
      padding: '12px 16px',
      borderRadius: '8px',
      margin: '0 0 8px 0',
      backgroundColor: '#303A49',
      color: '#fff',
    },
    '& .Mui-completed .MuiStepLabel-root': {
      backgroundColor: '#6FBD43',
      color: '#fff',
    },
      '& .MuiStep-root:not(.Mui-completed) .MuiStepLabel-root:not(.Mui-disabled)': {
      backgroundColor: '#1E72B8',
      color: '#fff',
    },
  },
  stepLabel: {
    '& .MuiStepLabel-label': {
      fontSize: '14px',
      fontWeight: 600,
      color: '#fff',
    },
    '& .MuiStepLabel-label.Mui-active': {
      color: '#fff',
    },
    '& .MuiStepLabel-label.Mui-completed': {
      color: '#fff',
    },
    '& .MuiStepLabel-iconContainer': {
      paddingRight: '12px',
    }
  },
  stepConnector: {
    marginLeft: '0',
    '& .MuiStepConnector-line': {
      display: 'none',
    }
  },
  stepContent: {
    marginLeft: "0 !important",
    borderLeftWidth: "0 !important",
    padding: "0 !important",
    marginBottom: "8px",
  }
}));

function CircleStepIcon(props) {
  const { active, completed, error, icon, ...rest } = props;
  
  return (
    <div {...rest} style={{ 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      color: '#fff'
    }}>
      {completed ? (
        <TickIcon style={{ width: 18 }} />
      ) : active ? (
        <RightArrowIcon style={{ width: 10 }} />
      ) : (
        <CrossIcon style={{ width: 14, color: "#fff" }} />
      )}
    </div>
  );
}


export default function VerticalLinearStepper(props) {
  const classes = useStyles();
  const steps = props.steps || [];
  return (
    <div className="stepper-wrapper">
      <Stepper
  activeStep={props.activeStep} 
  orientation="vertical" 
  elevation={0} 
  classes={{root: classes.stepRoot}}
  connector={
    <StepConnector 
      classes={{
        root: classes.stepConnector,
      }} 
    />
  }
>
        {steps.map((step, index) => (
  <Step 
    key={step.id}
  >
    <StepLabel
  StepIconComponent={CircleStepIcon}
  classes={{ root: classes.stepLabel }}
>
  <span style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
    <span>{props.translate(step.title)}</span>

    <span className={classes.rightArrow}>
      {props.activeStep === index ? (
        <DownArrowIcon style={{ width: "18px", transform: "rotate(180deg)" }} />
      ) : (
        <DownArrowIcon style={{ width: "18px" }} />
      )}
    </span>
  </span>
</StepLabel>

    <StepContent classes={{
      root: classes.stepContent
    }}>
              {props.getStepContent(step.id)}
              {step.errorMsg ? step.errorMsg : null}
              <div className={classes.actionsContainer}>
  <div>
    <div style={{
      display: 'flex', 
      justifyContent: 'flex-end', 
      gap: "10px"
    }}>
      {props.activeStep > 0 ? 
        <Button
          disabled={props.activeStep === 0}
          onClick={e => props.handleBack(step.id)}
          className={classes.button}
          style={{
            backgroundColor: '#424242',
            color: '#fff',
            border: 'none',
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: '6px',
            padding: '8px 20px',
            minWidth: '80px',
            boxShadow: 'none'
          }}
        >
          {props.translate('sharedBack')}
        </Button> 
      : null}
      
      {(props.isOtherReports && props.activeStep === steps.length - 1 && props.reportType) ? null :
        <Button
          variant="contained"
          color="primary"
          disabled={props.missedOpportunity && !props.isSubmitBtn}
          onClick={e => props.handleNext(step.id, '', index)}
          className={classes.button}
          style={{
            color: '#fff',
            textTransform: 'none',
            fontWeight: 500,
            borderRadius: '6px',
            padding: '8px 20px',
            minWidth: '80px',
            boxShadow: 'none',
            border: 'none'
          }}
        >
          {(props.activeStep === steps.length - 1 && props.reportType) ||
            (props.activeStep === 0 && props.missedOpportunity) || 
            (props.activeStep === 4 && props.services) ||
            ((props.activeStep === 2 && props.isSubmitBtn && !props.services) || props.activeStepInvo === 1) 
              ? props.translate('sharedSearch') 
              : props.translate('next')}
        </Button>
      }
    </div>
                  {props.activeStep === steps.length - 1 && props.reportType && props.download && props.emails ? <div>
                    <div className='report-sidebar-switch' style={{marginTop: 15}}></div>
                      <div style={{display: 'flex', justifyContent: 'center',gap:'10px'}}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={e => props.handleNext(step.id, 'downloadExcel', index)}
                          className={classes.button}
                        >
                          <GetApp/>
                          {props.translate('Excel')}
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={e => props.handleNext(step.id, 'downloadPdf', index)}
                          className={classes.button}
                        >
                          <GetApp/>
                          {props.translate('PDF')}
                        </Button>
                        {!props.isOtherReports&&
                                 <Button
                            variant="contained"
                            color="primary"
                            onClick={e => props.handleNext(step.id, 'email', index)}
                            className={classes.button}
                          >
                            <Email style={{marginRight: 5}}/>
                            {props.translate('commandSend')}
                          </Button>
                        }</div>
                      
                  </div> : null}
{/* -------------------------------------------------------------------------------------------------------------- */}
                              {((props.activeStep===0  && props.missedOpportunity ) || (props.activeStep===4  && props.services ))&& (
                              <div style={{display: 'flex', justifyContent: 'flex-end',marginTop:10}}>
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={e => props.handleNext(step.id, 'downloadExcel', index)}
                                className={classes.button}
                              >
                                <GetApp/>
                                {props.translate('Excel')}
                              </Button>
                              </div>

                              )}

                  {props.invoices && props.activeStep === 2 &&(
                      <div style={{display: 'flex', justifyContent: 'flex-end',gap:"10px",marginTop:15}}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={e => props.downloadInvoice()}
                          className={classes.button}
                        >
                          <GetApp/>
                          {props.translate('Excel')}
                        </Button>
                        {!props.generatePo&&
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={e => props.downloadInvoice("downloadPdf")}
                          className={classes.button}
                        >
                          <GetApp/>
                          {props.translate('PDF')}
                        </Button>
}
                      </div>
                  )}
                   {props.invoices && props.activeStepInvo &&(
                      <div style={{display: 'flex', justifyContent: 'flex-end',gap:"10px",marginTop:5,padding:"8px 0px"}}>
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={!props.btnDisable}
                          onClick={e => props.downloadInvoice()}
                          className={classes.button}
                        >
                          <GetApp/>
                          {props.translate('Excel')}
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={!props.btnDisable}
                          onClick={e => props.downloadInvoice("downloadPdf")}
                          className={classes.button}
                        >
                          <GetApp/>
                          {props.translate('PDF')}
                        </Button>
                      </div>
                  )}
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}